import { Navigate, useNavigate } from 'react-router-dom';
import { useSession } from '@/hooks/session';
import { FocusShell } from '@/components/layout';
import { useT } from '@/i18n';
import { PlusSubscribe } from '@/features/plan/PlusSubscribe';

/**
 * Session-less Nurture Plus subscription checkout — reached from the Settings plan card's
 * pitch when the account has no active plan yet. Renders the same subscribe flow the
 * session checkout embeds, minus the "spend this session's unlock" action, which needs a
 * specific assessment this page doesn't have. Once the subscription activates, we send the
 * visitor back to Settings, where the plan card now reflects it.
 */
export const Plus = () => {
  const t = useT();
  const navigate = useNavigate();
  const { config } = useSession();
  // Switched off in the admin console (and not already subscribed): nothing to sell here.
  if (config && !config.plans.plus) return <Navigate to="/settings" replace />;

  return (
    <FocusShell onBack={() => navigate('/settings')}>
      <div className="space-y-4">
        <h1 className="text-h1 text-ink">{t('plan.plus.title')}</h1>
        <PlusSubscribe onActivated={() => navigate('/settings', { replace: true })} />
      </div>
    </FocusShell>
  );
};
